/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step3_SubInputs */

const tr_landing_referral_step3_sub = /** @type {(inputs: Landing_Referral_Step3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk ödemeyle birlikte iki tarafa da 1 ay hediye.`)
};

const en_landing_referral_step3_sub = /** @type {(inputs: Landing_Referral_Step3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the first payment, both sides get 1 month free.`)
};

const de_landing_referral_step3_sub = /** @type {(inputs: Landing_Referral_Step3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit der ersten Zahlung erhalten beide Seiten 1 Monat geschenkt.`)
};

const ru_landing_referral_step3_sub = /** @type {(inputs: Landing_Referral_Step3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После первой оплаты обе стороны получают 1 месяц в подарок.`)
};

/**
* | output |
* | --- |
* | "With the first payment, both sides get 1 month free." |
*
* @param {Landing_Referral_Step3_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step3_sub = /** @type {((inputs?: Landing_Referral_Step3_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step3_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step3_sub(inputs)
	if (locale === "de") return de_landing_referral_step3_sub(inputs)
	if (locale === "ru") return ru_landing_referral_step3_sub(inputs)
	return tr_landing_referral_step3_sub(inputs)
});